import React, { Component } from "react";
import { ModalBody } from "react-bootstrap";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { GrCircleQuestion } from "react-icons/gr";
import { RiErrorWarningLine } from "react-icons/ri";
import { Modal } from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import { clients_config } from "../../base/services/services";
import { CgList } from "react-icons/cg";
import version from "../../settings/version";
import { fixObject } from "../../base/utils/convert_to_object";

class Setting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      logoutModal: false,
      redirect: false,
      properties: null,
    };
  }
  componentDidMount() {
    this.checkSeller();
    clients_config().then((items) => {
      items && this.setState({ properties: items });
    });
  }
  checkSeller() {
    if (window.location.search) {
      let params = fixObject(window.location.search);
      if (params && params.seller) {
        this.setState({ isSeller: true });
      }
    }
  }
  logout() {
    localStorage.clear();
    window.location.href = "/";
  }
  render() {
    if (this.state.redirect) {
      return <Redirect push to={"/profile"} />;
    }
    return (
      <div className="container-fluid px-4">
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0" }}
        >
          <div
            className="col-auto align-self-center px-0"
            onClick={() =>
              window.history.length > 1
                ? window.history.back()
                : this.setState({ redirect: true })
            }
          >
            <FiChevronRight size="26" className="" />
          </div>

          <div className="col align-self-center text-center px-0">
            <h1 className="fs-5 fw-bold mb-0">تنظیمات</h1>
          </div>
        </header>
        <body style={{ marginTop: "80px" }}>
          <div className="row mx-0 p-2">
            <div className="col-12 text-center">
              <img
                alt="logo"
                src={require("../../base/assets/images/main_logo.svg").default}
                className="w-75 mb-2"
              />
            </div>
            <div className="col-12 text-center fw-bold fs-6 mb-4 text-muted">
              نسخه
              {" " + version.versionCode}
            </div>
          </div>
          {this.state.properties &&
            ((!this.state.isSeller && this.state.properties.call_center) ||
              (this.state.isSeller &&
                this.state.properties.seller_call_center)) && (
              <a
                href={`tel:${
                  this.state.isSeller
                    ? this.state.properties.seller_call_center
                    : this.state.properties.call_center
                }`}
              >
                <div className="row mx-0 rounded14 border p-3">
                  <div className="col-auto px-1 align-self-center">
                    <GrCircleQuestion size="28" />
                  </div>
                  <div className="col px-1 fs-6 fw-bold align-self-center">
                    تماس با پشتیبانی
                  </div>
                  <div className="col-auto px-1 align-self-center">
                    <FiChevronLeft size="30" />
                  </div>
                </div>
              </a>
            )}
          <Link to="/feedback">
            <div className="row mt-3 mx-0 rounded14 border p-3">
              <div className="col-auto px-1 align-self-center">
                <RiErrorWarningLine size="28" />
              </div>
              <div className="col px-1 fs-6 fw-bold align-self-center">
                ارسال بازخورد
              </div>
              <div className="col-auto px-1 align-self-center">
                <FiChevronLeft size="30" />
              </div>
            </div>
          </Link>
          <Link to="/terms-of-use">
            <div className="row mt-3 mx-0 rounded14 border p-3">
              <div className="col-auto px-1 align-self-center">
                <CgList size="28" />
              </div>
              <div className="col px-1 fs-6 fw-bold align-self-center">
                قوانین و مقررات
              </div>
              <div className="col-auto px-1 align-self-center">
                <FiChevronLeft size="30" />
              </div>
            </div>
          </Link>

          <div className="row mt-4 mx-0 rounded14">
            <div
              className="col-12 px-1 align-self-center text-center"
              onClick={() => this.setState({ logoutModal: true })}
            >
              <button className="btn p-0 text-danger fs-6 fw-bold">
                خروج از حساب کاربری
              </button>
            </div>
          </div>
        </body>
        <Modal
          centered
          isOpen={this.state.logoutModal}
          toggle={() => this.setState({ logoutModal: false })}
        >
          <ModalBody className="p-4" dir="rtl">
            <div className="row mx-0">
              <div className="col-12">
                <div
                  className="bg-color-main p-3 rounded-2 mx-auto mb-3"
                  style={{ width: "33%" }}
                >
                  <img
                    className=""
                    src={
                      require("../../base/assets/images/logo_white.svg").default
                    }
                    alt="logo"
                  />
                </div>

                <p className="text-muted fw-bolder">
                  آیا برای خروج از گیتی مارکت اطمینان دارید؟
                </p>
              </div>
              <div className="col-12">
                <button
                  className="btn text-muted fw-bolder"
                  onClick={() => this.setState({ logoutModal: false })}
                >
                  انصراف
                </button>
                <button
                  className="btn fw-bolder text-danger"
                  onClick={() => this.logout()}
                >
                  خروج
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default Setting;
